import React from 'react';
import './ToolTips.scss';
import { UniqueID, CheckValue, CheckWidth } from '../../../services/CommonFunction';
import { SVG, selectIcon } from '../../UI/selector';
import { toolTipService } from '../../../services/subscriberService';

class ToolTips extends React.Component {
    constructor(props) {
      super(props);
      this.wrapperRef = React.createRef();  
      this.wrapperRef1 = React.createRef();  
      this.state = {
        displayTooltip: false,
        random: UniqueID(),
        element: null,
        overflow: true,
      };
  
      this.hideTooltip = this.hideTooltip.bind(this);
      this.showTooltip = this.showTooltip.bind(this);
    }

    componentDidMount() {
      this.setEventListner('addEventListener');
      if(CheckValue(this.props.overflow) && this.props.overflow) {
        const { width, height } = this.ele.getBoundingClientRect();
        const textWidth = CheckWidth(this.child.textContent,0,this.props.styleClas || '');

        this.setState({ overflow: (textWidth - 5) > Math.round(this.props.height?height:width)});
      }
    }

    setEventListner = (status) => {
      document[status]("mouseover", this.moveInside);
    }

    moveInside= (event) => {
      if (!this.state.displayTooltip && ((this.wrapperRef.current && this.wrapperRef.current.contains(event.target)) || (this.wrapperRef1.current && this.wrapperRef1.current.contains(event.target)))) {
        this.showTooltip();
      } else if(this.state.displayTooltip && (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) && (this.wrapperRef1.current && !this.wrapperRef1.current.contains(event.target))) {
        this.hideTooltip();
      }
    }

    get child () {
      const child = this.ele.firstChild instanceof HTMLElement?this.ele.firstChild:this.ele;
      return child;
    };

    get ele () {
      return document.getElementById(this.state.random);
    }

    componentWillUnmount() {
      this.hideTooltip();
      this.setEventListner('removeEventListener');
    }
    hideTooltip() {
      if(this.props.showTooltip) {
        toolTipService.sendToolTip(null);
        this.setState({ displayTooltip: false, element: null });
      }
    }

    showTooltip() {
      if(!this.state.displayTooltip && this.props.showTooltip && this.state.overflow) {
        // let position = this.props.position || 'left';
        let rect = this.child.getBoundingClientRect();
        this.toolTip(this.props.position || 'left',rect);
      }
    }

    toolTip = (position,rect) => {
      const msg = <span dangerouslySetInnerHTML={{"__html":this.props.message}}></span>;
      const div = <div ref={this.wrapperRef1} className={`tooltips-bubble tooltips-${position} ${this.props.clas || ''}`} style={{opacity:'0',zIndex:'-10'}}>
        <div className={`tooltip-message ${this.props.messageClass || ''}`}>
          {this.props.title? <span className='tooltip_message_span'>{this.props.title}</span>:null}
          {msg}
        </div>
      </div>
      toolTipService.sendToolTip(div);
      if(this.wrapperRef1.current) {

        let top = rect.top + window.scrollY;
        let left = rect.left + window.scrollX;
        
        const divRect = this.wrapperRef1.current.getBoundingClientRect();

        try {
          
          setTimeout(() => {
            if(this.wrapperRef1.current) {
              if(position === 'top') {
                const temp = this.wrapperRef1.current.getBoundingClientRect();
                const tempTop = top - (temp.height - divRect.height);
                this.wrapperRef1.current.style.top = tempTop+'px';
              }
              this.wrapperRef1.current.style.opacity='1';
              this.wrapperRef1.current.style.zIndex='99999';
              this.wrapperRef1.current.ref = this.wrapperRef;
            }
          },1);
          if(position === 'right') {
            top += rect.height/2;
            left += rect.width;
          } else if(position === 'top') {
            top -= divRect.height;
            left += rect.width/2;
          } else if(position === 'bottom') {
            top += rect.height;
            left += rect.width/2;
          } else {
            top += rect.height/2;
            left -= divRect.width;
          }
          this.wrapperRef1.current.style.left = left+'px';
          this.wrapperRef1.current.style.top = top+'px';
    
          this.setState({ displayTooltip: true, element: this.wrapperRef1.current });
        } catch (error) {
          console.error(error);
        }
      }
    }
  
    render() {
        // let message = this.props.message;
        // let position = this.props.position || 'left';
        return (
          <React.Fragment>
            <span ref={this.wrapperRef} className={`tooltip-trigger ${this.props.className || ''}`} id={this.state.random} meta-id={this.props.meta_id || null}>
              {this.props.children}
            </span>
          </React.Fragment>
        );
    }
}

export default ToolTips


export const InfoIcon = ({info,position}) => (
  <ToolTips showTooltip={true} position={position || 'right'} message={info} className="infoIcon"> 
    <SVG src={selectIcon('infoIcon')} />
  </ToolTips>
)